const appInfo = {
    title: 'ezTemplates',
    version: '1.0.0',
    company: 'Woodlands Digital Technologies, LLC',
    company_address: '',
    app_website_name: 'ezTemplates',
    app_website: '',
    company_email: 'contact@wdttx.com'
};
export default appInfo;
